import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketIoService {

  socket;
  
  listeners = [];

  constructor() {   }

  setupSocketConnection() {
    this.socket = io(environment.socket_url);
    this.socket.on('connect', function(){
      console.log("Cliente conectado");
    });
    
    this.socket.on('event', this.fireSocketEvent);
    
    this.socket.on('disconnect', function(){
      console.log("Cliente desconectado");
    });
  }

  registrar(listener){
    return (this.listeners.push(listener) - 1);
  }
  
  desRegistrar(index){
    this.listeners.splice(index, 1);
  }
  
  fireSocketEvent = (data) => {
    for (const evento of this.listeners)
      evento(data.event, data.data);
  }
}
